import React, { useState } from 'react';
import './About.css';
import './Contact.css';

const serviceOptions = [
  'W2 Tax Filing',
  '1099 / Self-Employed',
  'Business Tax Filing (LLC)',
  'Trucking Business Taxes',
  'Amended Return (1040X)',
  'ITIN Application',
  'IRS Letter / Audit Help',
  'Tax Planning',
  'Other',
];

const Contact = () => {
  const [form, setForm] = useState({
    firstName: '', lastName: '', phone: '', email: '',
    service: '', filingYear: '2024', message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const time = new Date().toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
    const line = '\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500';

    const msg = [
      '\u2733 *NEW QUOTE REQUEST*',
      '*A-Mobile Tax Services*',
      line,
      '*\u276F Field*          \u2502 *Details*',
      line,
      '\u2756 Full Name      \u2502 ' + form.firstName + ' ' + form.lastName,
      '\u260E Phone          \u2502 ' + form.phone,
      '\u2709 Email          \u2502 ' + form.email,
      '\u2318 Service        \u2502 ' + (form.service || 'Not selected'),
      '\u25A6 Filing Year    \u2502 ' + form.filingYear,
      line,
      '\u270D *Message:*',
      form.message || '~ None ~',
      line,
      '\u2713 Submitted: ' + time,
    ].join('\n');

    const waUrl = 'https://wa.me/12244154202?text=' + encodeURIComponent(msg);
    window.open(waUrl, '_blank', 'noopener,noreferrer');

    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setForm({ firstName: '', lastName: '', phone: '', email: '', service: '', filingYear: '2024', message: '' });
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="section-label">Get In Touch</div>
          <h1>Contact <em>A-Mobile Tax Services</em></h1>
          <p>Ready to get started? Reach out by phone, email, WhatsApp, or fill the form below.</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Info Side */}
            <div className="contact-info">
              <h3>We're Here to Help</h3>

              {[
                { icon: '📍', label: 'Our Location', value: '2033 Dodge Ave, Evanston, IL 60201' },
                { icon: '📞', label: 'Phone', value: '224-415-4202', href: 'tel:+12244154202' },
                { icon: '📧', label: 'Email', value: 'info@amobiletax.com', href: 'mailto:info@amobiletax.com' },
                { icon: '🕐', label: 'Business Hours', value: 'Mon–Sat: 9:00 AM – 7:00 PM\nSunday: By appointment only' },
              ].map(item => (
                <div className="contact-item" key={item.label}>
                  <div className="contact-icon">{item.icon}</div>
                  <div>
                    <strong>{item.label}</strong>
                    {item.href
                      ? <a href={item.href}>{item.value}</a>
                      : <p style={{ whiteSpace: 'pre-line' }}>{item.value}</p>
                    }
                  </div>
                </div>
              ))}

              <a
                href="https://wa.me/12244154202"
                target="_blank"
                rel="noreferrer"
                className="btn btn-whatsapp wa-contact-btn"
              >
                💬 Chat with Us on WhatsApp
              </a>

              {/* Map */}
              <div className="map-container">
                <iframe
                  title="A-Mobile Tax Services Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2963.77805!2d-87.6878!3d42.0450!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fd00!2s2033+Dodge+Ave+Evanston+IL!5e0!3m2!1sen!2sus"
                  width="100%"
                  height="220"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            {/* Form Side */}
            <div className="contact-form-box">
              <h3>📋 Get a Free Quote</h3>

              {submitted && (
                <div className="form-success">
                  ✅ Thank you! We'll contact you within 24 hours. For immediate help, call 224-415-4202.
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input name="firstName" value={form.firstName} onChange={handleChange} placeholder="John" required />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input name="lastName" value={form.lastName} onChange={handleChange} placeholder="Doe" required />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input name="phone" value={form.phone} onChange={handleChange} placeholder="(224) 000-0000" required />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@email.com" required />
                  </div>
                </div>

                <div className="form-group">
                  <label>Service Needed *</label>
                  <select name="service" value={form.service} onChange={handleChange} required>
                    <option value="">— Select a Service —</option>
                    {serviceOptions.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>

                <div className="form-group">
                  <label>Filing Year</label>
                  <select name="filingYear" value={form.filingYear} onChange={handleChange}>
                    <option>2024 (Current Year)</option>
                    <option>2023</option>
                    <option>2022</option>
                    <option>Multiple Years</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Message / Additional Details</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us a bit about your tax situation..."
                    rows={4}
                  />
                </div>

                <button type="submit" className="form-submit-btn">
                  💰 Submit &amp; Get My Free Quote
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
